/**
 * Modern UI Component Library
 *
 * Centralized export for all shared components
 * Following Linear/Stripe/Notion design aesthetics
 */

// Custom wrapped components
export { Button } from './Button';
export type { ButtonProps } from './Button';

export { Input, InputTextArea, InputPassword, InputSearch } from './Input';
export type { InputProps } from './Input';

export { Card } from './Card';
export type { CardProps } from './Card';

export { Select } from './Select';
export type { SelectProps } from './Select';

export { DataTable } from './DataTable';
export type { DataTableProps, InfiniteScrollProps } from './DataTable';

export { Loader } from './Loader';
export type { LoaderProps } from './Loader';

// Re-export Ant Design components with modern styling applied via global CSS
export {
  // Navigation
  Breadcrumb,
  Dropdown,
  Menu,
  Pagination,
  Steps,

  // Data Entry
  Checkbox,
  DatePicker,
  Radio,
  Switch,

  // Data Display
  Avatar,
  Descriptions,
  Table,
  Tabs,
  Tooltip,
  Typography,

  // Feedback
  Modal,
  Popover,

  // Layout
  Divider,
  Space,
  Row,
  Col,
  Layout,

  // Misc
  Badge,
  Tag,
  Spin,
  Progress,
} from 'antd';

import { Typography as AntTypography } from 'antd';

// Export types from Ant Design
export type {
  BreadcrumbProps,
  DropdownProps,
  MenuProps,
  PaginationProps,
  StepsProps,
  CheckboxProps,
  DatePickerProps,
  RadioProps,
  SwitchProps,
  AvatarProps,
  DescriptionsProps,
  TableProps,
  TabsProps,
  TooltipProps,
  ModalProps,
  PopoverProps,
  DividerProps,
  SpaceProps,
  BadgeProps,
  TagProps,
  RowProps,
  ColProps,
  LayoutProps,
  SpinProps,
  ProgressProps,
} from 'antd';

// Typography sub-components
export const { Title, Text, Paragraph, Link } = AntTypography;
